namespace GeniuzPOS.PosShift {
    export interface ReportVatRefundRow {
        Id?: string;
        RowNo?: number;
        DocDate?: string;
        BookNo?: string;
        No?: string;
        FristName?: string;
        Passport?: string;
        Total?: number;
        PayVatAmount?: number;
        Remark?: string;
    }

    export namespace ReportVatRefundRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BookNo';
        export const localTextPrefix = 'PosShift.ReportVatRefund';
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:VatRefund:View';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:VatRefund:View';
        export const readPermission = '1POSBASE:ใบกำกับภาษี:VatRefund:View';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:VatRefund:View';

        export declare const enum Fields {
            Id = "Id",
            RowNo = "RowNo",
            DocDate = "DocDate",
            BookNo = "BookNo",
            No = "No",
            FristName = "FristName",
            Passport = "Passport",
            Total = "Total",
            PayVatAmount = "PayVatAmount",
            Remark = "Remark"
        }
    }
}
